import React from 'react'
import { Link } from 'react-router-dom'

const NoPageFound = () => {
    return (
        <div className="p-7 bg-white border rounded-md auth-body">
            <form>
                <ul className="grid gap-4 list-none li_animate">
                    <li className="col-span-12 text-center">
                        <h1 className="text-6xl font-bold">404</h1>
                        <h5 className="text-lg mt-2">We couldn't find this page.</h5>
                    </li>
                    <li className="col-span-12 mt-4 mb-2">
                        <Link
                            className="block w-full py-3 bg-primary-900 text-white text-center rounded uppercase hover:bg-primray-800 transition"
                            to="/"
                            title=""
                        >
                            Back to Home
                        </Link>
                    </li>
                </ul>
            </form>
        </div>
    )
}

export default NoPageFound